import { getExecutorApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ExecutorResponse } from '@/core/generated/api';
import { normalizePersonSearchQuery } from '@/shared/lib/phone';

/** Предоставляет поиск исполнителей */
export const executorSearchService = {
    /** Ищет активных исполнителей по общей строке */
    async search(query: string, takeCount = 10): Promise<ExecutorResponse[]> {
        try {
            const response = await getExecutorApi()
                .getExecutors({
                    searchQuery: normalizePersonSearchQuery(query),
                    takeCount,
                    skipCount: 0,
                    isDeleted: false,
                });

            return response.data.executors ?? [];
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
